import { render, staticRenderFns } from "./Fxcoin.vue?vue&type=template&id=822b8c70&scoped=true"
import script from "./Fxcoin.vue?vue&type=script&lang=js"
export * from "./Fxcoin.vue?vue&type=script&lang=js"
import style0 from "./Fxcoin.vue?vue&type=style&index=0&id=822b8c70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822b8c70",
  null
  
)

export default component.exports